<template>
  <v-container >
    <v-row class="ma-0 pa-0">
      <v-col class="ma-0 pa-0 col-lg-9 col-sm-12">
        <v-row class="ma-0 pa-0 px-4">
          <v-col class="ma-0 pa-0" cols="4">
            <v-list-item class="ma-0 pa-0" two-line>
              <v-list-item-content>
                <v-list-item-title><p class="font-weight-bold">{{ $t('Global.Companies.companyName') }}</p></v-list-item-title>
                <v-list-item-subtitle class="mt-n3">{{ item.name }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-col>
          <v-col class="ma-0 pa-0" cols="8">
            <v-list-item class="ma-0 pa-0" two-line>
              <v-list-item-content>
                <v-list-item-title><p class="font-weight-bold">{{ $t('Global.Companies.description') }}</p></v-list-item-title>
                <v-list-item-subtitle class="mt-n3">{{ item.description }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-col>
          <v-col class="ma-0 pa-0" cols="4">
            <v-list-item class="ma-0 pa-0" two-line>
              <v-list-item-content>
                <v-list-item-title><p class="font-weight-bold">{{ $t('Global.Companies.licenceExpiration') }}</p></v-list-item-title>
                <v-list-item-subtitle class="mt-n3">{{ item.licenceExpiration }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-col>
          <v-col class="ma-0 pa-0" cols="4">
            <v-list-item class="ma-0 pa-0" two-line>
              <v-list-item-content>
                <v-list-item-title><p class="font-weight-bold">{{ $t('Global.Companies.licenceTypeId') }}</p></v-list-item-title>
                <v-list-item-subtitle class="mt-n3">{{ getLicenseName(item) }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-col>
          <v-col class="ma-0 pa-0" cols="4">
            <v-list-item class="ma-0 pa-0" two-line>
              <v-list-item-content>
                <v-list-item-title><p class="font-weight-bold">{{ $t('Global.Companies.fsCode') }}</p></v-list-item-title>
                <v-list-item-subtitle class="mt-n3">{{ item.fsCode }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-col>
          <v-col class="ma-0 pa-0" cols="4">
            <v-list-item class="ma-0 pa-0" two-line>
              <v-list-item-content>
                <v-list-item-title><p class="font-weight-bold">{{ $t('Global.Companies.xsiCompanyId') }}</p></v-list-item-title>
                <v-list-item-subtitle class="mt-n3">{{ item.xsiCompanyId }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-col>
          <v-col class="ma-0 pa-0" cols="4">
            <v-list-item class="ma-0 pa-0" two-line>
              <v-list-item-content>
                <v-list-item-title><p class="font-weight-bold">{{ $t('Global.Companies.xsiServiceType') }}</p></v-list-item-title>
                <v-list-item-subtitle class="mt-n3">{{ item.xsiServiceType }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-col>
          <v-col class="ma-0 pa-0" cols="4">
            <v-list-item class="ma-0 pa-0" two-line>
              <v-list-item-content>
                <v-list-item-title><p class="font-weight-bold">{{ $t('Global.Companies.email') }}</p></v-list-item-title>
                <v-list-item-subtitle class="mt-n3">{{ item.email }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-col>
        </v-row>
      </v-col>
      <v-col class="ma-0 pa-0 mt-3 col-lg-3 col-sm-12" >
        <v-badge
            left
            overlap
            color="error"
            :content="'sin sedes'"
            :value="!hasOffices"
        >
        <v-btn color="primary" class="mb-3 mr-1" @click="officesManager(item)" >{{ $t('Global.Companies.officesManagement') }}</v-btn>
        </v-badge>
        <v-btn color="primary" class="mb-3 mr-1" @click="nodesManager(item)" >{{ $t('Global.Companies.nodesManager') }}</v-btn>
        <v-btn color="primary" class="mb-3" @click="usersManager(item)" >{{ $t('Global.Companies.usersManager') }}</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
  name: "CompanyExpansion",
  props: {
    item: {
      type: Object,
      required: true
    },
    headers: {
      type: Array,
      required: true
    }
  },
  computed: {
    ...mapGetters(['getEditCompanyInfo', 'getDefsLicenceTypes']),
    hasOffices(){
      return !!this.item?.offices?.length
    }
  },
  methods: {
    ...mapActions(["setEditCompanyInfoUser"]),
      async officesManager(item) {
        await this.setEditCompanyInfoUser({
          companyId: item.companyId,
          companyName: item.name
        })
        await this.$router.push({name: 'adminOffices'})
      },
      async nodesManager(item) {
        await this.setEditCompanyInfoUser({
          companyId: item.companyId,
          companyName: item.name,
          companyOffices: item.offices,
        })
        await this.$router.push({name: 'adminNodos'})
      },
      async usersManager(item) {
        await this.setEditCompanyInfoUser({
          companyId: item.companyId,
          companyName: item.name,
        })
        await this.$router.push({name: 'adminUsers'})
      },
    getLicenseName(item) {
      return this.getDefsLicenceTypes?.find((e) => e.licenseTypeId === item.licenseTypeId)?.licenseTypeName
    },
    },
}
</script>

<style>

</style>
